// Mapping and helpers for placing entity notes into organized folders
// Adjust this mapping to fit your preferred structure.

const DEFAULT_ENTITY_FOLDERS = {
  character: 'Characters',
  npc: 'NPCs',
  monster: 'Monsters',
  spell: 'Spells',
  equipment: 'Equipment',
  item: 'Items',
  campaign: 'Campaigns',
  location: 'Locations',
  quest: 'Quests'
}

function capitalize(word = '') {
  return word ? word.charAt(0).toUpperCase() + word.slice(1) : ''
}

function defaultFolderFor(type = '') {
  const t = String(type || '').toLowerCase()
  if (!t) return 'Other'
  // naive pluralization: add 's' if not already plural
  const base = capitalize(t)
  const plural = /s$/.test(base) ? base : `${base}s`
  return plural
}

export function getEntityFolder(entityType) {
  const key = String(entityType || '').toLowerCase()
  return DEFAULT_ENTITY_FOLDERS[key] || defaultFolderFor(key)
}

export default { getEntityFolder }
